import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const getOrders = async ({ queryKey, pageParam = 1 }) => {
  const [_key, { limit, search, projectName, searchBy, filterBy, finalStartDate, finalEndDate, isArchive }] = queryKey;

  const payload = {
    pageNumber: pageParam,
    limit,
    searchTerm: search,
    projectName,
    searchBy,
    filterBy,
    startDate: finalStartDate,
    endDate: finalEndDate,
    isArchive,
  };

  const response = await apiClient.post("/api/v3/client/vision_order", payload);

  if (response.status !== 200) {
    throw new Error("Error fetching order data");
  }

  return {
    orderData: response.data.orderData,
    currentPage: response.data.currentPage,
    totalPages: response.data.totalPages,
    totals: response.data.totals,
  };
};

export const useOrders = ({ limit = 5, search, projectName, searchBy, filterBy = "", finalStartDate, finalEndDate, isArchive }) => {
  return useInfiniteQuery({
    queryKey: ["orders", { limit, search, projectName, searchBy, filterBy, finalStartDate, finalEndDate, isArchive }],
    queryFn: getOrders,
    getNextPageParam: (lastPage) => {
      if (lastPage.currentPage < lastPage.totalPages) {
        return lastPage.currentPage + 1;
      }
      return undefined;
    },
  });
};
